module.exports = __webpack_public_path__ + "static/media/savethedate.408ea4cb.jpeg";